import { toast } from 'sonner'

import { env } from '@/env'
import { downloadAuthenticatedFile } from '@/lib/download-file'

async function exportCsv(url: string, filename: string): Promise<void> {
  try {
    await downloadAuthenticatedFile(url, filename)
  } catch (caughtError) {
    const message =
      caughtError instanceof Error ? caughtError.message : 'Failed to export CSV'
    toast.error('Export failed', { description: message })
  }
}

export function exportClients(): void {
  void exportCsv(`${env.VITE_API_BASE_URL}/api/exports/clients`, 'clients-export.csv')
}

export function exportInvoices(): void {
  void exportCsv(`${env.VITE_API_BASE_URL}/api/exports/invoices`, 'invoices-export.csv')
}

export function exportQuotes(): void {
  void exportCsv(`${env.VITE_API_BASE_URL}/api/exports/quotes`, 'quotes-export.csv')
}

export function exportLineItems(): void {
  void exportCsv(
    `${env.VITE_API_BASE_URL}/api/exports/line-items`,
    'line-items-export.csv',
  )
}

export function exportExpenses(type?: 'BUSINESS' | 'REIMBURSEMENT'): void {
  const url = new URL(`${env.VITE_API_BASE_URL}/api/exports/expenses`)
  if (type) url.searchParams.set('type', type)
  void exportCsv(url.toString(), 'expenses-export.csv')
}

export interface AccountingExportFilters {
  startDate?: string
  endDate?: string
  status?: string
}

export function exportAccountingInvoices(
  format: 'xero' | 'myob',
  filters: AccountingExportFilters = {},
): Promise<void> {
  const url = new URL(`${env.VITE_API_BASE_URL}/api/exports/accounting/invoices`)
  url.searchParams.set('format', format)
  if (filters.startDate) url.searchParams.set('startDate', filters.startDate)
  if (filters.endDate) url.searchParams.set('endDate', filters.endDate)
  if (filters.status) url.searchParams.set('status', filters.status)

  const fileName =
    format === 'xero' ? 'xero-invoices-export.csv' : 'myob-invoices-export.txt'
  return exportCsv(url.toString(), fileName)
}
